(function () {
  const STORAGE_KEY = 'recently_viewed';
  const MAX_ITEMS = 8;

  function getStored() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveStored(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
  }

  function addCurrentProduct() {
    if (!window.RECENTLY_VIEWED_PRODUCT) return;

    const product = window.RECENTLY_VIEWED_PRODUCT;
    let items = getStored();

    items = items.filter(item => item.handle !== product.handle);
    items.unshift(product);

    saveStored(items);
  }

  document.addEventListener('DOMContentLoaded', function () {
    addCurrentProduct();
  });
})();